import { Member } from 'types/splits.types';
import { formatValue } from 'app/components/Song/Splits/utils';

export const sortSplitMembers = (
  selectedMembers: Member[],
  possibleMembers?: Member[]
) =>
  selectedMembers.sort((a, b) =>
    possibleMembers
      ? possibleMembers.findIndex(
          (e) => e.memberIdentifier === a.memberIdentifier
        ) -
        possibleMembers.findIndex(
          (e) => e.memberIdentifier === b.memberIdentifier
        )
      : 0
  );

export const getMembersValues = (
  previousValues: Member[],
  splitMembers: Member[],
  currentMembers: Member[]
) =>
  Object.values(splitMembers).map((member) => {
    const previousValue = previousValues.find(
      (prevVal: { memberIdentifier: string }) =>
        prevVal.memberIdentifier === member.memberIdentifier
    );
    const currentSplitValue = currentMembers?.find(
      (currentSplitMember: Member) =>
        currentSplitMember.memberIdentifier === member.memberIdentifier
    );
    return {
      memberIdentifier: member.memberIdentifier,
      share: formatValue(
        previousValue?.share || currentSplitValue?.share || '0.00'
      ),
    };
  });

export const getDefaultSplitMembers = (
  possibleMembers?: Member[],
  currentMembers?: Member[]
) =>
  currentMembers?.filter((member) => member?.valid !== false) ||
  possibleMembers ||
  [];
